import type { AvailableStock } from "@fero/pages";
import type { NumberOfUnits, ProductId } from "adl-gen/ferovinum/app/db";
import { useMemo } from "react";
import { useGetStockQuery } from "../../../../../hooks/react-query/queries/physical-stock";

interface getStock {
  aggregatedStock: AvailableStock;
  isLoading: boolean;
  isError: boolean;
}

export function useGetStock(
  organisationId: string,
  storageLocationId: string,
): getStock {
  const {
    data: availableStock = [],
    isLoading,
    isError,
  } = useGetStockQuery(organisationId, storageLocationId);

  const aggregatedStock = useMemo(() => {
    return availableStock.reduce((aggregatedStockMap, stock) => {
      const existing = aggregatedStockMap.get(stock.product_id);
      const quantityValue = Number(stock.quantity);

      // Map from Unit type (uppercase) to NumberOfUnits kind (lowercase)
      const unitKindMap = {
        SINGLES: "singles" as const,
        LITRESOFPUREALCOHOL: "litresOfPureAlcohol" as const,
        HECTOLITRES: "hectolitres" as const,
      };

      const kind = unitKindMap[stock.unit] || ("singles" as const);

      return new Map(aggregatedStockMap).set(stock.product_id, {
        kind,
        value: (existing?.value || 0) + quantityValue,
      });
    }, new Map<ProductId, NumberOfUnits>());
  }, [availableStock]);

  return { aggregatedStock, isLoading, isError };
}
